// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useOutletContext } from "react-router-dom";
// import "./ServitorNotificationPage.css";

// const getNotificationStyle = (notif) => {
//   // For demo purposes, let’s do a very naive check based on message keywords.
//   let style = {
//     borderClass: "",       // e.g. "urgent" or "order" or "system" etc.
//     iconClass: "fas fa-bell", // fallback
//     iconBgColor: "#eef7ff",
//     iconColor: "#3498db",
//   };

//   const msg = notif.message?.toLowerCase() || "";

//   if (msg.includes("expiring")) {
//     style.borderClass = "urgent";
//     style.iconClass = "fas fa-exclamation-circle";
//     style.iconBgColor = "#fef1f0";
//     style.iconColor = "#e74c3c";
//   } else if (msg.includes("order assigned") || msg.includes("service request")) {
//     style.borderClass = "order";
//     style.iconClass = "fas fa-clipboard-list";
//     style.iconBgColor = "#e6f7f1";
//     style.iconColor = "#2ecc71";
//   } else if (msg.includes("maintenance")) {
//     style.borderClass = "system";
//     style.iconClass = "fas fa-cog";
//     style.iconBgColor = "#fff8e6";
//     style.iconColor = "#f39c12";
//   } else if (msg.includes("review")) {
//     // star icon
//     style.borderClass = "review";
//     style.iconClass = "fas fa-star";
//     style.iconBgColor = "#eef7ff";
//     style.iconColor = "#3498db";
//   } else if (msg.includes("payment") || msg.includes("balance")) {
//     // money icon
//     style.borderClass = "payment";
//     style.iconClass = "fas fa-money-bill-wave";
//     style.iconBgColor = "#eefff6";
//     style.iconColor = "#27ae60";
//   }

//   return style;
// };

// const ServitorNotificationPage = () => {
//   const { servitor } = useOutletContext();
//   const [notifications, setNotifications] = useState([]);
//   // For demo, track unread vs read in state. 
//   // In reality, you might get this info from your server response.
//   const [unreadIds, setUnreadIds] = useState([]);
//   const [filter, setFilter] = useState("All Notifications");

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         if (servitor && servitor.Id) {
//           const response = await axios.get(
//             `http://localhost:4001/notifications/servitor/${servitor.Id}`
//           );
//           const data = response.data;
//           setNotifications(data);

//           // If your API has a field like `notif.isRead`, use that. 
//           // For demo, assume all are unread:
//           const allIds = data.map((n) => n.id);
//           setUnreadIds(allIds);
//         }
//       } catch (error) {
//         console.error("Error fetching servitor notifications:", error);
//       }
//     };
//     fetchNotifications();
//   }, [servitor]);

//   const handleMarkAllRead = () => {
//     // In a real app, you’d call an API endpoint to mark them all read.
//     setUnreadIds([]);
//   };

//   const handleMarkRead = (id) => {
//     // Real app: call your “mark single notification read” API
//     setUnreadIds((prev) => prev.filter((nid) => nid !== id));
//   };

//   // Example filter logic: you can adjust to match your actual categories
//   const filteredNotifications = notifications.filter((notif) => {
//     if (filter === "All Notifications") return true;
//     if (filter === "Unread Only") {
//       return unreadIds.includes(notif.id);
//     }
//     const msg = notif.message?.toLowerCase() || "";
//     if (filter === "Orders") {
//       return msg.includes("order");
//     }
//     if (filter === "System") {
//       return msg.includes("maintenance") || msg.includes("system");
//     }
//     if (filter === "Payments") {
//       return msg.includes("payment") || msg.includes("balance");
//     }
//     return true;
//   });

//   return (
//     <div className="notif-page-wrapper">
//       {/* If you have a header or sidebar, place it above or alongside. 
//           Here we just show the core notifications section. */}

//       <h1 className="page-title">Notifications</h1>

//       {/* Filter bar */}
//       <div className="filters">
//         <div className="filter-group">
//           <div className="filter-label">Filter by:</div>
//           <select
//             className="filter-select"
//             value={filter}
//             onChange={(e) => setFilter(e.target.value)}
//           >
//             <option>All Notifications</option>
//             <option>Unread Only</option>
//             <option>Orders</option>
//             <option>System</option>
//             <option>Payments</option>
//           </select>
//         </div>
//         <button className="mark-all-read" onClick={handleMarkAllRead}>
//           Mark All as Read
//         </button>
//       </div>

//       {/* If no notifications after filtering */}
//       {filteredNotifications.length === 0 ? (
//         <p className="no-notif">No notifications found.</p>
//       ) : (
//         filteredNotifications.map((notif) => {
//           const style = getNotificationStyle(notif);
//           const isUnread = unreadIds.includes(notif.id);

//           return (
//             <div
//               key={notif.id}
//               className={`notification-card ${style.borderClass} ${
//                 isUnread ? "unread" : ""
//               }`}
//               onClick={() => handleMarkRead(notif.id)}
//             >
//               <div
//                 className="notification-icon"
//                 style={{ backgroundColor: style.iconBgColor }}
//               >
//                 <i className={style.iconClass} style={{ color: style.iconColor }} />
//               </div>
//               <div className="notification-content">
//                 {/* You could have a "title" prop if your backend provides one.
//                     For the example, we just show the message. */}
//                 <div className="notification-title">{notif.title || notif.message}</div>
//                 <div className="notification-message">{notif.message}</div>
//                 <div className="notification-time">
//                   {new Date(notif.createdAt).toLocaleString()}
//                 </div>
//               </div>

//               {/* Example action button on the right */}
//               <button
//                 className="notification-action"
//                 onClick={(e) => {
//                   e.stopPropagation(); // prevent marking read on button click
//                   alert("Perform some action here, e.g. link to Order details.");
//                 }}
//               >
//                 {notif.message?.toLowerCase().includes("order") ? "View Order" : "Open"}
//               </button>
//             </div>
//           );
//         })
//       )}
//     </div>
//   );
// };

// export default ServitorNotificationPage;





// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate, useOutletContext } from "react-router-dom";
// import "./ServitorNotificationPage.css";

// // const getNotificationStyle = (notif) => {
// //   // Determine styles based on notification message keywords
// //   let style = {
// //     borderClass: "", // e.g., "urgent", "order", etc.
// //     iconClass: "fas fa-bell", // default icon
// //     iconBgColor: "#eef7ff",
// //     iconColor: "#3498db",
// //   };

// //   const msg = notif.message?.toLowerCase() || "";

// //   if (msg.includes("expiring")) {
// //     style.borderClass = "urgent";
// //     style.iconClass = "fas fa-exclamation-circle";
// //     style.iconBgColor = "#fef1f0";
// //     style.iconColor = "#e74c3c";
// //   } else if (msg.includes("order assigned") || msg.includes("order")) {
// //     style.borderClass = "order";
// //     style.iconClass = "fas fa-clipboard-list";
// //     style.iconBgColor = "#e6f7f1";
// //     style.iconColor = "#2ecc71";
// //   } else if (msg.includes("maintenance") || msg.includes("system")) {
// //     style.borderClass = "system";
// //     style.iconClass = "fas fa-cog";
// //     style.iconBgColor = "#fff8e6";
// //     style.iconColor = "#f39c12";
// //   } else if (msg.includes("review")) {
// //     style.borderClass = "review";
// //     style.iconClass = "fas fa-star";
// //     style.iconBgColor = "#eef7ff";
// //     style.iconColor = "#3498db";
// //   } else if (msg.includes("payment") || msg.includes("balance")) {
// //     style.borderClass = "payment";
// //     style.iconClass = "fas fa-money-bill-wave";
// //     style.iconBgColor = "#eefff6";
// //     style.iconColor = "#27ae60";
// //   }

// //   return style;
// // };

// function getNotificationProps(notif) {
//   // Default/fallback props
//   let props = {
//     borderClass: "",             // e.g. "urgent", "order", etc. for styling
//     iconClass: "fas fa-bell",    // default icon
//     iconBgColor: "#eef7ff",
//     iconColor: "#3498db",
//     title: "Notification",       // fallback title
//   };

//   // If your backend has a 'type' field, check that first:
//   switch (notif.type) {
//     case "deadline_warning_pending":
//       props.borderClass = "urgent";
//       props.iconClass = "fas fa-exclamation-circle";
//       props.iconBgColor = "#fef1f0";
//       props.iconColor = "#e74c3c";
//       props.title = "Deadline Warning (Pending)";
//       break;

//     case "order_cancelled":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-ban";
//       props.iconBgColor = "#ffe6e6";
//       props.iconColor = "#d9534f";
//       props.title = "Order Cancelled";
//       break;

//     case "deadline_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "fas fa-exclamation-triangle";
//       props.iconBgColor = "#fef5e6";
//       props.iconColor = "#f39c12";
//       props.title = "Deadline Warning";
//       break;

//     case "order_time_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "fas fa-clock";
//       props.iconBgColor = "#fff7e6";
//       props.iconColor = "#f39c12";
//       props.title = "Order Time Running Out";
//       break;

//     case "order_in_progress":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-spinner";
//       props.iconBgColor = "#eef7ff";
//       props.iconColor = "#3498db";
//       props.title = "Order In-Progress";
//       break;

//     case "order_completed":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-check-circle";
//       props.iconBgColor = "#e6ffed";
//       props.iconColor = "#10b981";
//       props.title = "Order Completed";
//       break;

//     default:
//       break;
//   }

//   return props;
// }

// const formatRelativeTime = (dateString) => {
//   const now = new Date();
//   const date = new Date(dateString);
//   const diffMs = now - date;
//   const diffSec = Math.floor(diffMs / 1000);
//   const diffMin = Math.floor(diffSec / 60);
//   const diffHour = Math.floor(diffMin / 60);
//   const diffDay = Math.floor(diffHour / 24);

//   if (diffDay > 0) {
//     return diffDay === 1 ? "1 day ago" : `${diffDay} days ago`;
//   } else if (diffHour > 0) {
//     return diffHour === 1 ? "1 hour ago" : `${diffHour} hours ago`;
//   } else if (diffMin > 0) {
//     return diffMin === 1 ? "1 minute ago" : `${diffMin} minutes ago`;
//   } else {
//     return "Just now";
//   }
// };


// const ServitorNotificationPage = () => {
//   const { servitor } = useOutletContext();
//   const [notifications, setNotifications] = useState([]);
//   const [unreadIds, setUnreadIds] = useState([]);
//   const [filter, setFilter] = useState("All Notifications");
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         if (servitor && servitor.Id) {
//           const response = await axios.get(
//             `http://localhost:4001/notifications/servitor/${servitor.Id}`
//           );
//           const data = response.data;
//           setNotifications(data);
//           // Use the capitalized "Id" field from notifications
//           const allIds = data.map((n) => n.Id);
//           setUnreadIds(allIds);
//         }
//       } catch (error) {
//         console.error("Error fetching servitor notifications:", error);
//       }
//     };
//     fetchNotifications();
//   }, [servitor]);

//   const handleMarkAllRead = () => {
//     // In a real app, you would call an API endpoint to mark them as read.
//     setUnreadIds([]);
//   };

//   const handleMarkRead = (id) => {
//     // In a real app, call your API to mark the notification as read
//     setUnreadIds((prev) => prev.filter((nid) => nid !== id));
//   };

//   const filteredNotifications = notifications.filter((notif) => {
//     if (filter === "All Notifications") return true;
//     if (filter === "Unread Only") return unreadIds.includes(notif.Id);
//     const msg = notif.message?.toLowerCase() || "";
//     if (filter === "Orders") {
//       return msg.includes("order");
//     }
//     if (filter === "System") {
//       return msg.includes("maintenance") || msg.includes("system");
//     }
//     if (filter === "Payments") {
//       return msg.includes("payment") || msg.includes("balance");
//     }
//     return true;
//   });
  

//   return (
//     <div className="notif-page-wrapper">
//       <h1 className="page-title">Notifications</h1>
//       <div className="filters">
//         <div className="filter-group">
//           <div className="filter-label">Filter by:</div>
//           <select
//             className="filter-select"
//             value={filter}
//             onChange={(e) => setFilter(e.target.value)}
//           >
//             <option>All Notifications</option>
//             <option>Unread Only</option>
//             <option>Orders</option>
//             <option>System</option>
//             <option>Payments</option>
//           </select>
//         </div>
//         <button className="mark-all-read" onClick={handleMarkAllRead}>
//           Mark All as Read
//         </button>
//       </div>
//       {filteredNotifications.length === 0 ? (
//         <p className="no-notif">No notifications found.</p>
//       ) : (
//         filteredNotifications.map((notif) => {
//           // const style = getNotificationStyle(notif);
//           const props = getNotificationProps(notif);
//           const isUnread = unreadIds.includes(notif.Id);
//           return (
//             <div
//               key={notif.Id}
//               className={`notification-card ${props.borderClass} ${
//                 isUnread ? "unread" : ""
//               }`}
//               onClick={() => handleMarkRead(notif.Id)}
//             >
//               <div
//                 className="notification-icon"
//                 style={{ backgroundColor: props.iconBgColor }}
//               >
//                 <i className={props.iconClass} style={{ color: props.iconColor }} />
//               </div>
//               <div className="notification-content">
//                 <div className="notification-title">
//                   {props.title}
//                 </div>
//                 <div className="notification-message">{notif.message}</div>
//                 <div className="notification-time">
//                   {/* {new Date(notif.created_at).toLocaleString()} */}
//                   {formatRelativeTime(notif.created_at)}
//                 </div>
//               </div>
//               <button
//                 className="notification-action"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   if (notif.orderNumber) {
//                     navigate(`/servitor/orders/${notif.orderNumber}`);
//                   } else {
//                     // Fallback: You can perform a default action if no order number is present.
//                     alert("No order information available.");
//                   }
//                 }}
//               >
//                 {notif.message.toLowerCase().includes("order")
//                   ? "View Order"
//                   : "Open"}
//               </button>
//             </div>
//           );
//         })
//       )}
//     </div>
//   );
// };

// export default ServitorNotificationPage;








// ***** All checked, working fine (26-6-25) ***** //
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate, useOutletContext } from "react-router-dom";
// import "./ServitorNotificationPage.css";

// function getNotificationProps(notif) {
//   // Default/fallback props
//   let props = {
//     borderClass: "",             // e.g. "urgent", "order", etc. for styling
//     iconClass: "fas fa-bell",    // default icon
//     iconBgColor: "#eef7ff",
//     iconColor: "#3498db",
//     title: "Notification",       // fallback title
//   };

//   // If your backend has a 'type' field, check that first:
//   switch (notif.type) {
//     case "deadline_warning_pending":
//       props.borderClass = "urgent";
//       props.iconClass = "fas fa-exclamation-circle";
//       props.iconBgColor = "#fef1f0";
//       props.iconColor = "#e74c3c";
//       props.title = "Deadline Warning (Pending)";
//       break;

//     case "order_cancelled":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-ban";
//       props.iconBgColor = "#ffe6e6";
//       props.iconColor = "#d9534f";
//       props.title = "Order Cancelled";
//       break;

//     case "deadline_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "fas fa-exclamation-triangle";
//       props.iconBgColor = "#fef5e6";
//       props.iconColor = "#f39c12";
//       props.title = "Deadline Warning";
//       break;

//     case "order_time_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "fas fa-clock";
//       props.iconBgColor = "#fff7e6";
//       props.iconColor = "#f39c12";
//       props.title = "Order Time Running Out";
//       break;

//     case "order_in_progress":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-spinner";
//       props.iconBgColor = "#eef7ff";
//       props.iconColor = "#3498db";
//       props.title = "Order In-Progress";
//       break;

//     case "order_completed":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-check-circle";
//       props.iconBgColor = "#e6ffed";
//       props.iconColor = "#10b981";
//       props.title = "Order Completed";
//       break;

//     default:
//       break;
//   }

//   return props;
// };

// const formatRelativeTime = (dateString) => {
//   const now = new Date();
//   const date = new Date(dateString);
//   const diffMs = now - date;
//   const diffSec = Math.floor(diffMs / 1000);
//   const diffMin = Math.floor(diffSec / 60);
//   const diffHour = Math.floor(diffMin / 60);
//   const diffDay = Math.floor(diffHour / 24);

//   if (diffDay > 0) {
//     return diffDay === 1 ? "1 day ago" : `${diffDay} days ago`;
//   } else if (diffHour > 0) {
//     return diffHour === 1 ? "1 hour ago" : `${diffHour} hours ago`;
//   } else if (diffMin > 0) {
//     return diffMin === 1 ? "1 minute ago" : `${diffMin} minutes ago`;
//   } else {
//     return "Just now";
//   }
// };

// const ServitorNotificationPage = () => {
//   const { servitor } = useOutletContext();
//   const [notifications, setNotifications] = useState([]);
//   const [unreadIds, setUnreadIds] = useState([]);
//   const [filter, setFilter] = useState("All Notifications");
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         if (servitor && servitor.Id) {
//           const response = await axios.get(
//             `http://localhost:4001/notifications/servitor/${servitor.Id}`
//           );
//           const data = response.data;
//           setNotifications(data);
//           // Save all notification Ids as unread initially
//           const allIds = data.filter(n => !n.isRead).map((n) => n.Id);
//           setUnreadIds(allIds);
//         }
//       } catch (error) {
//         console.error("Error fetching servitor notifications:", error);
//       }
//     };
//     fetchNotifications();
//   }, [servitor]);

//   // Updated handleMarkRead to persist the "read" state
//   const handleMarkRead = async (id) => {
//     try {
//       const response = await axios.patch(`http://localhost:4001/notifications/${id}/read`);
//       if (response.status === 200) {
//         setUnreadIds((prev) => prev.filter((nid) => nid !== id));
//       }
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };

//   // Updated handleMarkAllRead to call API for each unread notification
//   const handleMarkAllRead = async () => {
//     try {
//       const unreadNotifications = notifications.filter((notif) => unreadIds.includes(notif.Id));
//       await Promise.all(
//         unreadNotifications.map((notif) =>
//           axios.patch(`http://localhost:4001/notifications/${notif.Id}/read`)
//         )
//       );
//       // Update local state to mark all as read
//       setUnreadIds([]);
//     } catch (error) {
//       console.error("Error marking all notifications as read:", error);
//     }
//   };

//   const filteredNotifications = notifications.filter((notif) => {
//     if (filter === "All Notifications") return true;
//     if (filter === "Unread Only") return unreadIds.includes(notif.Id);
//     const msg = notif.message?.toLowerCase() || "";
//     if (filter === "Orders") {
//       return msg.includes("order");
//     }
//     if (filter === "System") {
//       return msg.includes("maintenance") || msg.includes("system");
//     }
//     if (filter === "Payments") {
//       return msg.includes("payment") || msg.includes("balance");
//     }
//     return true;
//   });
  
//   return (
//     <div className="notif-page-wrapper">
//       <h1 className="page-title">Notifications</h1>
//       <div className="filters">
//         <div className="filter-group">
//           <div className="filter-label">Filter by:</div>
//           <select
//             className="filter-select"
//             value={filter}
//             onChange={(e) => setFilter(e.target.value)}
//           >
//             <option>All Notifications</option>
//             <option>Unread Only</option>
//             <option>Orders</option>
//             <option>System</option>
//             <option>Payments</option>
//           </select>
//         </div>
//         <button className="mark-all-read" onClick={handleMarkAllRead}>
//           Mark All as Read
//         </button>
//       </div>
//       {filteredNotifications.length === 0 ? (
//         <p className="no-notif">No notifications found.</p>
//       ) : (
//         filteredNotifications.map((notif) => {
//           const props = getNotificationProps(notif);
//           const isUnread = unreadIds.includes(notif.Id);
//           return (
//             <div
//               key={notif.Id}
//               className={`notification-card ${props.borderClass} ${
//                 isUnread ? "unread" : ""
//               }`}
//               onClick={async () => {
//                 await handleMarkRead(notif.Id);
//               }}
//             >
//               <div
//                 className="notification-icon"
//                 style={{ backgroundColor: props.iconBgColor }}
//               >
//                 <i className={props.iconClass} style={{ color: props.iconColor }} />
//               </div>
//               <div className="notification-content">
//                 <div className="notification-title">
//                   {props.title}
//                 </div>
//                 <div className="notification-message">{notif.message}</div>
//                 <div className="notification-time">
//                   {formatRelativeTime(notif.created_at)}
//                 </div>
//               </div>
//               <button
//                 className="notification-action"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   if (notif.orderNumber) {
//                     navigate(`/servitor/orders/${notif.orderNumber}`);
//                   } else {
//                     alert("No order information available.");
//                   }
//                 }}
//               >
//                 {notif.message.toLowerCase().includes("order")
//                   ? "View Order"
//                   : "Open"}
//               </button>
//             </div>
//           );
//         })
//       )}
//     </div>
//   );
// };

// export default ServitorNotificationPage;


// ***** Upper code All checked, working fine (26-6-25) ***** //





// ***** Add Translate EN BN (26-6-25) ***** //


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate, useOutletContext } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import "./ServitorNotificationPage.css";
// import { URL } from "../../../config";
// import Loader from "../../../Components/LoaderSpin/Loader";

// function getNotificationProps(notif, t) {
//   // Default/fallback props
//   let props = {
//     borderClass: "",             // e.g. "urgent", "order", etc. for styling
//     iconClass: "fas fa-bell",    // default icon
//     iconBgColor: "#eef7ff",
//     iconColor: "#3498db",
//     // title: "Notification",       // fallback title
//     title: t("notifications.notification_titles.default"),
//   };

//   // If your backend has a 'type' field, check that first:
//   switch (notif.type) {
//     case "deadline_warning_pending":
//       props.borderClass = "urgent";
//       props.iconClass = "fas fa-exclamation-circle";
//       props.iconBgColor = "#fef1f0";
//       props.iconColor = "#e74c3c";
//       // props.title = "Deadline Warning (Pending)";
//       props.title = t("notifications.notification_titles.deadline_warning_pending");
//       break;

//     case "order_cancelled":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-ban";
//       props.iconBgColor = "#ffe6e6";
//       props.iconColor = "#d9534f";
//       // props.title = "Order Cancelled";
//       props.title = t("notifications.notification_titles.order_cancelled");
//       break;

//     case "deadline_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "fas fa-exclamation-triangle";
//       props.iconBgColor = "#fef5e6";
//       props.iconColor = "#f39c12";
//       // props.title = "Deadline Warning";
//       props.title = t("notifications.notification_titles.deadline_warning");
//       break;

//     case "order_time_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "fas fa-clock";
//       props.iconBgColor = "#fff7e6";
//       props.iconColor = "#f39c12";
//       // props.title = "Order Time Running Out";
//       props.title = t("notifications.notification_titles.order_time_warning");
//       break;

//     case "order_in_progress":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-spinner";
//       props.iconBgColor = "#eef7ff";
//       props.iconColor = "#3498db";
//       // props.title = "Order In-Progress";
//       props.title = t("notifications.notification_titles.order_in_progress");
//       break;

//     case "order_completed":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-check-circle";
//       props.iconBgColor = "#e6ffed";
//       props.iconColor = "#10b981";
//       // props.title = "Order Completed";
//       props.title = t("notifications.notification_titles.order_completed");
//       break;

//     case "penalty_applied":
//       props.borderClass = "urgent";
//       props.iconClass = "fas fa-exclamation-circle";
//       props.iconBgColor = "#fef1f0";
//       props.iconColor = "#e74c3c";
//       props.title = t("notifications.notification_titles.penalty_applied");
//       break;

//     default:
//       break;
//   }

//   return props;
// };


// function parseNotificationMessage(notif, t) { // NEW: Added function to parse and translate messages
//   // Extract orderNumber and other dynamic parts from the message
//   const orderNumberMatch = notif.message.match(/order (\w+-\d+)/);
//   const orderNumber = orderNumberMatch ? orderNumberMatch[1] : notif.orderNumber || "Unknown";
  
//   // Extract penaltyAmount for penalty_applied notifications
//   const penaltyAmountMatch = notif.message.match(/A penalty of (\d+) taka/);
//   const penaltyAmount = penaltyAmountMatch ? penaltyAmountMatch[1] : "Unknown";

//   // Return translated message based on notification type
//   switch (notif.type) {
//     case "order_in_progress":
//       return t("notifications.notification_messages.order_in_progress", { orderNumber });
//     case "order_completed":
//       return t("notifications.notification_messages.order_completed", { orderNumber });
//     case "order_cancelled":
//       return t("notifications.notification_messages.order_cancelled", { orderNumber });
//     case "deadline_warning":
//       return t("notifications.notification_messages.deadline_warning", { orderNumber });
//     case "order_time_warning":
//       return t("notifications.notification_messages.order_time_warning", { orderNumber });
//     case "penalty_applied":
//       return t("notifications.notification_messages.penalty_applied", { orderNumber, penaltyAmount });
//     default:
//       return notif.message; // Fallback to original message if type is unknown
//   }
// }

// const formatRelativeTime = (dateString, t) => {
//   const now = new Date();
//   const date = new Date(dateString);
//   const diffMs = now - date;
//   const diffSec = Math.floor(diffMs / 1000);
//   const diffMin = Math.floor(diffSec / 60);
//   const diffHour = Math.floor(diffMin / 60);
//   const diffDay = Math.floor(diffHour / 24);

//   // if (diffDay > 0) {
//   //   return diffDay === 1 ? "1 day ago" : `${diffDay} days ago`;
//   // } else if (diffHour > 0) {
//   //   return diffHour === 1 ? "1 hour ago" : `${diffHour} hours ago`;
//   // } else if (diffMin > 0) {
//   //   return diffMin === 1 ? "1 minute ago" : `${diffMin} minutes ago`;
//   // } else {
//   //   return "Just now";
//   // }

//   if (diffDay > 0) {
//     return diffDay === 1
//       ? t("notifications.time.one_day_ago")
//       : t("notifications.time.days_ago", { count: diffDay });
//   } else if (diffHour > 0) {
//     return diffHour === 1
//       ? t("notifications.time.one_hour_ago")
//       : t("notifications.time.hours_ago", { count: diffHour });
//   } else if (diffMin > 0) {
//     return diffMin === 1
//       ? t("notifications.time.one_minute_ago")
//       : t("notifications.time.minutes_ago", { count: diffMin });
//   } else {
//     return t("notifications.time.just_now");
//   }

// };

// const ServitorNotificationPage = () => {
//   const { t } = useTranslation("servitor");

//   const { servitor } = useOutletContext();
//   const [notifications, setNotifications] = useState([]);
//   const [unreadIds, setUnreadIds] = useState([]);
//   // const [filter, setFilter] = useState("All Notifications");
//   const [filter, setFilter] = useState(t("notifications.filter_all"));
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         setLoading(true);
//         if (servitor && servitor.Id) {
//           const response = await axios.get(
//             `${URL}/notifications/servitor/${servitor.Id}`
//           );
//           const data = response.data;
//           setNotifications(data);
//           // Save all notification Ids as unread initially
//           const allIds = data.filter(n => !n.isRead).map((n) => n.Id);
//           setUnreadIds(allIds);
//         }
//       } catch (error) {
//         console.error("Error fetching servitor notifications:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchNotifications();
//   }, [servitor]);

//   // Updated handleMarkRead to persist the "read" state
//   const handleMarkRead = async (id) => {
//     try {
//       const response = await axios.patch(`${URL}/notifications/${id}/read`);
//       if (response.status === 200) {
//         setUnreadIds((prev) => prev.filter((nid) => nid !== id));
//       }
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };

//   // Updated handleMarkAllRead to call API for each unread notification
//   const handleMarkAllRead = async () => {
//     try {
//       const unreadNotifications = notifications.filter((notif) => unreadIds.includes(notif.Id));
//       await Promise.all(
//         unreadNotifications.map((notif) =>
//           axios.patch(`${URL}/notifications/${notif.Id}/read`)
//         )
//       );
//       // Update local state to mark all as read
//       setUnreadIds([]);
//     } catch (error) {
//       console.error("Error marking all notifications as read:", error);
//     }
//   };

//   // const filteredNotifications = notifications.filter((notif) => {
//   //   if (filter === "All Notifications") return true;
//   //   if (filter === "Unread Only") return unreadIds.includes(notif.Id);
//   //   const msg = notif.message?.toLowerCase() || "";
//   //   if (filter === "Orders") {
//   //     return msg.includes("order");
//   //   }
//   //   if (filter === "System") {
//   //     return msg.includes("maintenance") || msg.includes("system");
//   //   }
//   //   if (filter === "Payments") {
//   //     return msg.includes("payment") || msg.includes("balance");
//   //   }
//   //   return true;
//   // });

//   const filteredNotifications = notifications.filter((notif) => {
//     if (filter === t("notifications.filter_all")) return true; // CHANGED: Used translated value
//     if (filter === t("notifications.filter_unread")) return unreadIds.includes(notif.Id); // CHANGED: Used translated value
//     if (filter === t("notifications.filter_orders")) { // CHANGED: Updated filter logic
//       return [
//         "order_in_progress",
//         "order_completed",
//         "order_cancelled",
//         "deadline_warning",
//         "order_time_warning",
//       ].includes(notif.type);
//     }
//     if (filter === t("notifications.filter_payments")) { // CHANGED: Updated filter logic
//       return notif.type === "penalty_applied";
//     }
//     if (filter === t("notifications.filter_system")) { // CHANGED: Updated filter logic
//       return notif.type === "system"; // Assuming system notifications have this type
//     }
//     return true;
//   });
  
//   return (
//     <div className="notif-page-wrapper">
//       <Loader show={loading} />
//       {/* <h1 className="page-title">Notifications</h1> */}
//       <h1 className="page-title">{t("notifications.page_title")}</h1>
//       <div className="filters">
//         <div className="filter-group">
//           {/* <div className="filter-label">Filter by:</div> */}
//           <div className="filter-label">{t("notifications.filter_by")}</div>
//           <select
//             className="filter-select"
//             value={filter}
//             onChange={(e) => setFilter(e.target.value)}
//           >
//             {/* <option>All Notifications</option>
//             <option>Unread Only</option>
//             <option>Orders</option>
//             <option>System</option>
//             <option>Payments</option> */}

//             <option>{t("notifications.filter_all")}</option>
//             <option>{t("notifications.filter_unread")}</option>
//             <option>{t("notifications.filter_orders")}</option>
//             <option>{t("notifications.filter_system")}</option>
//             <option>{t("notifications.filter_payments")}</option>

//           </select>
//         </div>
//         <button className="mark-all-read" onClick={handleMarkAllRead}>
//           {/* Mark All as Read */}
//           {t("notifications.mark_all_read")}
//         </button>
//       </div>
//       {filteredNotifications.length === 0 ? (
//         // <p className="no-notif">No notifications found.</p>
//         <p className="no-notif">{t("notifications.no_notifications")}</p>

//       ) : (
//         filteredNotifications.map((notif) => {
//           const props = getNotificationProps(notif, t);
//           const isUnread = unreadIds.includes(notif.Id);
//           return (
//             <div
//               key={notif.Id}
//               className={`notification-card ${props.borderClass} ${
//                 isUnread ? "unread" : ""
//               }`}
//               onClick={async () => {
//                 await handleMarkRead(notif.Id);
//               }}
//             >
//               <div
//                 className="notification-icon"
//                 style={{ backgroundColor: props.iconBgColor }}
//               >
//                 <i className={props.iconClass} style={{ color: props.iconColor }} />
//               </div>
//               <div className="notification-content">
//                 <div className="notification-title">
//                   {props.title}
//                 </div>
//                 <div className="notification-message">
//                   {parseNotificationMessage(notif, t)}
//                 </div>
//                 <div className="notification-time">
//                   {formatRelativeTime(notif.created_at, t)}
//                 </div>
//               </div>
//               <button
//                 className="notification-action"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   if (notif.orderNumber) {
//                     navigate(`/servitor/orders/${notif.orderNumber}`);
//                   } else {
//                     alert(t("notifications.no_order_info"));
//                   }
//                 }}
//               >
//                 {[
//                   "order_in_progress",
//                   "order_completed",
//                   "order_cancelled",
//                   "deadline_warning",
//                   "order_time_warning",
//                 ].includes(notif.type)
//                   ? t("notifications.view_order")
//                   : t("notifications.open")}
//               </button>
//             </div>
//           );
//         })
//       )}
//     </div>
//   );
// };

// export default ServitorNotificationPage;







// ***** New update with loader and 10 data limit (19-Oct-2025) ***** //


import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./ServitorNotificationPage.css";
import { URL } from "../../../config";
import Loader from "../../../Components/LoaderSpin/Loader";
import { Spinner } from "react-bootstrap";


/* ------- helpers you already have ------- */
function getNotificationProps(notif, t) {
  let props = {
    borderClass: "",
    iconClass: "fas fa-bell",
    iconBgColor: "#eef7ff",
    iconColor: "#3498db",
    title: t("notifications.notification_titles.default"),
  };
  

  switch (notif.type) {
    case "deadline_warning_pending":
      props.borderClass = "urgent";
      props.iconClass = "fas fa-exclamation-circle";
      props.iconBgColor = "#fef1f0";
      props.iconColor = "#e74c3c";
      props.title = t("notifications.notification_titles.deadline_warning_pending");
      break;
    case "order_cancelled":
      props.borderClass = "order";
      props.iconClass = "fas fa-ban";
      props.iconBgColor = "#ffe6e6";
      props.iconColor = "#d9534f";
      props.title = t("notifications.notification_titles.order_cancelled");
      break;
    case "deadline_warning":
      props.borderClass = "urgent";
      props.iconClass = "fas fa-exclamation-triangle";
      props.iconBgColor = "#fef5e6";
      props.iconColor = "#f39c12";
      props.title = t("notifications.notification_titles.deadline_warning");
      break;
    case "order_time_warning":
      props.borderClass = "urgent";
      props.iconClass = "fas fa-clock";
      props.iconBgColor = "#fff7e6";
      props.iconColor = "#f39c12";
      props.title = t("notifications.notification_titles.order_time_warning");
      break;
    case "order_in_progress":
      props.borderClass = "order";
      props.iconClass = "fas fa-spinner";
      props.iconBgColor = "#eef7ff";
      props.iconColor = "#3498db";
      props.title = t("notifications.notification_titles.order_in_progress");
      break;
    case "order_completed":
      props.borderClass = "order";
      props.iconClass = "fas fa-check-circle";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.order_completed");
      break;
    case "penalty_applied":
      props.borderClass = "urgent";
      props.iconClass = "fas fa-exclamation-circle";
      props.iconBgColor = "#fef1f0";
      props.iconColor = "#e74c3c";
      props.title = t("notifications.notification_titles.penalty_applied");
      break;

    case "order_updated":
      props.borderClass = "order";
      props.iconClass = "fas fa-clipboard-check";
      props.iconBgColor = "#e6f7ed";
      props.iconColor = "#2ecc71";
      props.title = t("notifications.notification_titles.order_updated");
      break;


    case "report_received":
      props.borderClass = "order";
      props.iconClass = "fas fa-life-ring";
      props.iconBgColor = "#e6f0ff";
      props.iconColor = "#2563eb";
      props.title = t("notifications.notification_titles.report_received");
      break;

    case "report_opened_counterparty":
      props.borderClass = "urgent";
      props.iconClass = "fas fa-flag";
      props.iconBgColor = "#f3e8ff";
      props.iconColor = "#7c3aed";
      props.title = t("notifications.notification_titles.report_opened_counterparty");
      break;
    
    case "report_closed":
      props.borderClass = "order-completed";
      props.iconClass = "fas fa-life-ring";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.report_closed");
      break;

    case "reward_points_awarded":
      props.borderClass = "order";
      props.iconClass = "fas fa-trophy";
      props.iconBgColor = "#e6f0ff";
      props.iconColor = "#2563eb";
      props.title = t("notifications.notification_titles.reward_points_awarded");
      break;

    case "discount_bonus":
      props.borderClass = "payment";
      props.iconClass = "fas fa-wallet";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.discount_bonus");
      break;

    case "reward_claimed":
      props.borderClass = "payment";
      props.iconClass = "fas fa-wallet";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.reward_claimed");
      break;

    case "account_blocked":
      props.borderClass = "urgent";
      props.iconClass = "fas fa-user-lock";
      props.iconBgColor = "#fef1f0";
      props.iconColor = "#e11d48";
      props.title = t("notifications.notification_titles.account_blocked");
      break;

    case "referral_bonus":
      props.borderClass = "payment";
      props.iconClass = "fas fa-coins";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.referral_bonus");
      break;

    case "wallet_credit":
      props.borderClass = "payment";
      props.iconClass = "fas fa-wallet";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.wallet_credit");
      break;

    case "order_assigned":
      props.borderClass = "order";
      props.iconClass = "fas fa-user-check";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#16a34a";
      props.title = t("notifications.notification_titles.order_assigned");
      break;

    case "order_rescheduled":
      props.borderClass = "order";
      props.iconClass = "fas fa-calendar-alt";
      props.iconBgColor = "#eef7ff";
      props.iconColor = "#2563eb";
      props.title = t("notifications.notification_titles.order_rescheduled");
      break;

    case "account_approved":
      props.borderClass = "payment";
      props.iconClass = "bi bi-patch-check-fill"; // if you have this; otherwise use "fas fa-check-circle"
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#16a34a";
      props.title = t("notifications.notification_titles.account_approved");
      break;

    case "account_reapproved":
      props.borderClass = "system";
      props.iconClass = "fas fa-user-check";
      props.iconBgColor = "#eef7ff";
      props.iconColor = "#2563eb";
      props.title = t("notifications.notification_titles.account_reapproved");
      break;

    case "account_approved_no_bonus":
      props.borderClass = "payment";
      props.iconClass = "bi bi-patch-check-fill";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#16a34a";
      props.title = t("notifications.notification_titles.account_approved_no_bonus");
      break;

    case "account_blocked_admin":
      props.borderClass = "urgent";
      props.iconClass = "fas fa-user-lock"; 
      props.iconBgColor = "#fef1f0";
      props.iconColor = "#e11d48";
      props.title = t("notifications.notification_titles.account_blocked_admin");
      break;


    case "tutor_user_approved":
      props.borderClass = "order";
      props.iconClass = "fas fa-user-check";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#16a34a";
      props.title = t("notifications.notification_titles.tutor_user_approved");
      break;

    case "tutor_reassigned":
      props.borderClass = "order-cancelled";
      props.iconClass = "fas fa-user-times";
      props.iconBgColor = "#ffe6e6";
      props.iconColor = "#e11d48";
      props.title = t("notifications.notification_titles.tutor_reassigned");
      break;

    case "tutor_hired":
      props.borderClass = "order-completed";
      props.iconClass = "fas fa-briefcase";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.tutor_hired");
      break;

    case "recharge_balance":
      props.borderClass = "payment";
      props.iconClass = "fas fa-wallet";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.recharge_balance");
      break;

    case "recharge_rejected":
      props.borderClass = "payment";
      props.iconClass = "fas fa-exclamation-circle";
      props.iconBgColor = "#fef1f0";
      props.iconColor = "#e11d48";
      props.title = t("notifications.notification_titles.recharge_rejected");
      break;



    default:
      break;
  }
  return props;
}

const parseAmount = (msg) => {
     const m = msg?.match(/[৳$]?\s*([0-9]+(?:\.[0-9]+)?)/);
     return m ? Number(m[1]) : undefined;
   };
   const parseNote = (msg) => {
     if (!msg) return undefined;
     const byDash = msg.split("—");
     if (byDash.length > 1) return byDash.slice(1).join("—").trim().replace(/\.$/, "");
     const byHyphen = msg.split(" - ");
     if (byHyphen.length > 1) return byHyphen.slice(1).join(" - ").trim().replace(/\.$/, "");
     return undefined;
   };

function parseNotificationMessage(notif, t) {
  const orderNumberMatch = notif.message?.match?.(/order (\w+-\d+)/);
  const orderNumber = orderNumberMatch ? orderNumberMatch[1] : notif.orderNumber || "Unknown";
  const penaltyAmountMatch = notif.message?.match?.(/A penalty of (\d+) taka/);
  const penaltyAmount = penaltyAmountMatch ? penaltyAmountMatch[1] : "Unknown";

  switch (notif.type) {
    case "order_in_progress":
      return t("notifications.notification_messages.order_in_progress", { orderNumber });
    case "order_completed":
      return t("notifications.notification_messages.order_completed", { orderNumber });
    case "order_cancelled":
      return t("notifications.notification_messages.order_cancelled", { orderNumber });
    case "deadline_warning":
      return t("notifications.notification_messages.deadline_warning", { orderNumber });
    case "order_time_warning":
      return t("notifications.notification_messages.order_time_warning", { orderNumber });
    case "penalty_applied":
      return t("notifications.notification_messages.penalty_applied", { orderNumber, penaltyAmount });

    case "order_updated": {
      const ord =
        notif.orderNumber ||
        notif.message?.match?.(/order\s+([A-Z]+-\d+)/i)?.[1] ||
        "Unknown";
      const m = notif.message?.match?.(/extended\s+by\s+(\d+)\s*minute/i);
      const minutes = m ? parseInt(m[1], 10) : undefined;

      return minutes
        ? t("notifications.notification_messages.order_updated_with_time", { orderNumber: ord, minutes })
        : t("notifications.notification_messages.order_updated", { orderNumber: ord });
    }


    case "report_received": {
      const orderNumber = notif.orderNumber || "Unknown";
      return t("notifications.notification_messages.report_received", { orderNumber });
    }
    case "report_opened_counterparty": {
      const orderNumber = notif.orderNumber || "Unknown";
      return t("notifications.notification_messages.report_opened_counterparty", { orderNumber });
    }

    case "reward_claimed": {
     const claimAmount =
       typeof notif.claimAmount === "number"
         ? notif.claimAmount
         : (() => {
             const m = notif.message?.match?.(/(\d+)\s*tk/i);
             return m ? parseInt(m[1], 10) : undefined;
           })();
     return t("notifications.notification_messages.reward_claimed", { claimAmount });
   }

    case "report_closed": {
      const orderNumber = notif.orderNumber || "Unknown";
      const raw = notif.status || notif.message?.match?.(/\bis (\w+)\b/i)?.[1] || "resolved";
      const statusLabel = t(`notifications.status.${raw}`, raw);
      return t("notifications.notification_messages.report_closed", { orderNumber, status: statusLabel });
    }

    case "reward_points_awarded": {
      const count = (() => {
        const m = notif.message?.match?.(/earned\s+(\d+)\s+point/i);
        return m ? parseInt(m[1], 10) : undefined;
      })();
      const ord = (() => {
        if (notif.orderNumber) return notif.orderNumber;
        const m = notif.message?.match?.(/for\s+([A-Z]+-\d+)/i);
        return m ? m[1] : "Unknown";
      })();
      return t("notifications.notification_messages.reward_points_awarded", {
        count,
        orderNumber: ord,
      });
    }

    case "discount_bonus": {
      const amount = (() => {
        const m = notif.message?.match?.(/additional\s+(\d+)\s+taka/i);
        return m ? parseInt(m[1], 10) : undefined;
      })();
      const couponCode = (() => {
        const m = notif.message?.match?.(/\(([A-Za-z0-9-]+)\)/);
        return m ? m[1] : undefined;
      })();
      return t("notifications.notification_messages.discount_bonus", {
        amount,
        couponCode: couponCode || t("notifications.unknown"),
      });
    }

    case "account_blocked": {
      const orderNumber = notif.orderNumber || "Unknown";
      return t("notifications.notification_messages.account_blocked", { orderNumber });
    }

    case "referral_bonus": {
      // Try to derive amount from the message (handles ৳, $, or digits)
      const amt = (() => {
        const m = notif.message?.match(/[৳$]?\s*([0-9]+(?:\.[0-9]+)?)/);
        return m ? Number(m[1]) : undefined;
      })();

      // Heuristic: message contains "first recharge" => self; otherwise referrer
      const isSelf = /first\s+recharge/i.test(notif.message || "");
      return isSelf
        ? t("notifications.notification_messages.referral_bonus_self", { amount: amt })
        : t("notifications.notification_messages.referral_bonus_referrer", { amount: amt });
    }

    case "wallet_credit": {
       const amount = typeof notif.amount === "number" ? notif.amount : parseAmount(notif.message);
       const note = notif.note || parseNote(notif.message);
       const base = t("notifications.notification_messages.wallet_credit", { amount });
       return note ? `${base} ${t("notifications.note_prefix")}${note}` : base;
     }


     case "order_assigned": {
      const ord =
        notif.orderNumber ||
        notif.message?.match?.(/order\s+([A-Z]+-\d+)/i)?.[1] ||
        "Unknown";
      return t("notifications.notification_messages.order_assigned", { orderNumber: ord });
    }

    case "order_rescheduled": {
      const ord =
        notif.orderNumber ||
        notif.message?.match?.(/order\s+([A-Z]+-\d+)/i)?.[1] ||
        "Unknown";
      const whenMatch = notif.message?.match?.(/\bto\s+(.+?)\.?$/i);
      const whenText = notif.whenText || (whenMatch ? whenMatch[1] : undefined);
      return t("notifications.notification_messages.order_rescheduled", {
        orderNumber: ord,
        whenText: whenText || t("notifications.unknown"),
      });
    }

    case "account_approved": {
      const amount =
        typeof notif.amount === "number" ? notif.amount : parseAmount(notif.message);
      return t("notifications.notification_messages.account_approved", { amount });
    }

    case "account_reapproved":
      return t("notifications.notification_messages.account_reapproved");
    
    case "account_approved_no_bonus":
      return t("notifications.notification_messages.account_approved_no_bonus");

    case "account_blocked_admin":
      return t("notifications.notification_messages.account_blocked_admin");



    case "tutor_user_approved":
      return t("notifications.notification_messages.tutor_user_approved", { orderNumber });

    case "tutor_reassigned":
      return t("notifications.notification_messages.tutor_reassigned", { orderNumber });

    case "tutor_hired":
      return t("notifications.notification_messages.tutor_hired", { orderNumber });


        case "recharge_balance": {
      const amount =
        typeof notif.amount === "number"
          ? notif.amount
          : parseAmount(notif.message);
      return t("notifications.notification_messages.recharge_balance", {
        amount,
      });
    }

    case "recharge_rejected": {
      const amount =
        typeof notif.amount === "number"
          ? notif.amount
          : parseAmount(notif.message);
      return t("notifications.notification_messages.recharge_rejected", {
        amount,
      });
    }



    default:
      return notif.message || "";
  }
}

const formatRelativeTime = (dateString, t) => {
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now - date;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffDay > 0) {
    return diffDay === 1
      ? t("notifications.time.one_day_ago")
      : t("notifications.time.days_ago", { count: diffDay });
  } else if (diffHour > 0) {
    return diffHour === 1
      ? t("notifications.time.one_hour_ago")
      : t("notifications.time.hours_ago", { count: diffHour });
  } else if (diffMin > 0) {
    return diffMin === 1
      ? t("notifications.time.one_minute_ago")
      : t("notifications.time.minutes_ago", { count: diffMin });
  } else {
    return t("notifications.time.just_now");
  }
};
/* --------------------------------------- */

const ServitorNotificationPage = () => {
  const { t } = useTranslation("servitor");
  const navigate = useNavigate();
  const { servitor } = useOutletContext();

  // data + unread state
  const [notifications, setNotifications] = useState([]);
  const [unreadIds, setUnreadIds] = useState([]);

  // pagination + loading
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const sentinelRef = useRef(null);

  // reset when servitor changes
  useEffect(() => {
    setPage(1);
    setHasMore(true);
    setNotifications([]);
    setUnreadIds([]);
  }, [servitor?.Id]);

  const fetchPage = useCallback(async () => {
    if (!servitor?.Id || !hasMore) return;

    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("limit", "10");

    try {
      if (page === 1) setInitialLoading(true);
      else setLoadingMore(true);

      const { data } = await axios.get(
        `${URL}/notifications/servitor/${servitor.Id}?${params.toString()}`
      );

      const incoming = Array.isArray(data?.data) ? data.data : [];
      setHasMore(Boolean(data?.hasMore));

      // Append or replace
      setNotifications((prev) => (page === 1 ? incoming : [...prev, ...incoming]));

      // Track unread IDs (merge + dedupe)
      const incomingUnread = incoming.filter(n => !n.isRead).map(n => n.Id);
      setUnreadIds((prev) => {
        const set = new Set(page === 1 ? incomingUnread : [...prev, ...incomingUnread]);
        return Array.from(set);
      });
    } catch (e) {
      console.error("Error fetching notifications:", e);
      setHasMore(false);
    } finally {
      setInitialLoading(false);
      setLoadingMore(false);
    }
  }, [servitor?.Id, page, hasMore]);

  // initial + subsequent page loads
  useEffect(() => {
    fetchPage();
  }, [fetchPage]);

  // infinite scroll observer
  useEffect(() => {
    if (!sentinelRef.current) return;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loadingMore && hasMore && !initialLoading) {
          setPage((p) => p + 1);
        }
      },
      { rootMargin: "200px" }
    );

    obs.observe(sentinelRef.current);
    return () => obs.disconnect();
  }, [loadingMore, hasMore, initialLoading]);

  const handleMarkRead = async (id) => {
    try {
      const response = await axios.patch(`${URL}/notifications/${id}/read`);
      if (response.status === 200) {
        setUnreadIds((prev) => prev.filter((nid) => nid !== id));
        // Patch local item so UI reflects read immediately
        setNotifications((prev) =>
          prev.map((n) => (n.Id === id ? { ...n, isRead: true } : n))
        );
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const handleMarkAllRead = async () => {
    try {
      const unread = notifications.filter((n) => unreadIds.includes(n.Id));
      await Promise.all(unread.map((n) => axios.patch(`${URL}/notifications/${n.Id}/read`)));
      setUnreadIds([]);
      // Update local list
      setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
    }
  };


  // Which notifications should link to an order page?
const ORDER_TYPES = new Set([
  "order_in_progress",
  "order_completed",
  "order_cancelled",
  "deadline_warning",
  "order_time_warning",
  "order_update",
  "order_updated",
  "order_assigned",    
  "order_rescheduled", 
  "penalty_applied",
  "report_received",
  // "report_opened_counterparty",
  // "report_closed",
  // "account_approved",
  // "account_reapproved",
  "tutor_user_approved",
  "tutor_reassigned",
  "tutor_hired"
]);


  return (
    <div className="notif-page-wrapper">
      <Loader show={initialLoading} />


      <div className="notif-header">
        <h1 className="page-title">{t("notifications.page_title")}</h1>
        {notifications.length > 0 && (
          <button className="mark-all-read" onClick={handleMarkAllRead}>
            <i className="fas fa-check-double" aria-hidden="true"></i>
      <span>{t("notifications.mark_all_read")}</span>
            {/* {t("notifications.mark_all_read")} */}
          </button>
        )}
      </div>


      {/* List */}
      {notifications.length === 0 && !initialLoading ? (
        <p className="no-notif">{t("notifications.no_notifications")}</p>
      ) : (
        notifications.map((notif) => {
          const props = getNotificationProps(notif, t);
          const isUnread = unreadIds.includes(notif.Id);
          return (
            <div
              key={notif.Id}
              className={`notification-card ${props.borderClass} ${isUnread ? "unread" : ""}`}
              onClick={async () => {
                await handleMarkRead(notif.Id);
              }}
            >
              <div
                className="notification-icon"
                style={{ backgroundColor: props.iconBgColor }}
              >
                <i className={props.iconClass} style={{ color: props.iconColor }} />
              </div>

              <div className="notification-content">
                <div className="notification-title">{props.title}</div>
                <div className="notification-message">
                  {parseNotificationMessage(notif, t)}
                </div>
                <div className="notification-time">
                  {formatRelativeTime(notif.created_at, t)}
                </div>
              </div>

              {/* <button
                className="notification-action"
                onClick={(e) => {
                  e.stopPropagation();
                  if (notif.orderNumber) {
                    navigate(`/servitor/orders/${notif.orderNumber}`);
                  } else {
                    alert(t("notifications.no_order_info"));
                  }
                }}
              >
                {[
                  "order_in_progress",
                  "order_completed",
                  "order_cancelled",
                  "deadline_warning",
                  "order_time_warning",
                ].includes(notif.type)
                  ? t("notifications.view_order")
                  : t("notifications.open")}
              </button> */}

              <button
                  className="notification-action"
                  onClick={(e) => {
                    e.stopPropagation();

                    const isOrderType = ORDER_TYPES.has(notif.type);
                    const hasOrderNumber = Boolean(notif.orderNumber);

                    // Prefer the order page when we truly have an order number
                    const target = isOrderType && hasOrderNumber
                      ? `/servitor/orders/${notif.orderNumber}`
                      : `/servitor/servitor-profile`;

                    navigate(target);
                  }}
                >
                  {ORDER_TYPES.has(notif.type) && notif.orderNumber
                    ? t("notifications.view_order")
                    : t("notifications.open_profile")}
                </button>

            </div>
          );
        })
      )}

      {/* sentinel for infinite scroll */}
      {hasMore && !initialLoading && (
        <div ref={sentinelRef} className="servitorsite-sentinel">
          {loadingMore && (
            <div className="servitorsite-loader">
              <Spinner animation="border" role="status" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ServitorNotificationPage;
